<template>
  <div
    :class="variant === 'v1' ? 'sign__wrapper' : 'sign__wrapper-v2'"
  >
    <div
      class="login-page login-page__left-boxes"
      v-if="variant === 'v1'"
    >
      <GetTrial redirect />
      <Login redirect />
    </div>

    <div
      v-else
      class="login-page"
      :class="{ 'change-order': variant === 'v4' }"
    >
      <template
        v-if="isSignUpView"
      >
        <div
          :class="['login-page__images', { 'login-page__images--center': variant === 'v3', 'login-page__images--left': variant === 'v4' }]"
        >
          <SignInSignUpImagesContent :variant="variant" />
        </div>
        <div class="login-page__right-boxes">
          <GetTrialV2
            :variant="variant"
            @toggle-view="toggleView"
            redirect
          />
          <NavigateToLogin
            :toggle-view="toggleView"
          />
        </div>
      </template>

      <template v-else>
        <div :class="`images--center images--border-${variant === 'v4' ? 'left' : 'right'}`">
          <FeatureHighlight />
        </div>
        <div class="login-page__right-boxes">
          <LoginV2 redirect />
          <NavigateToTrial :toggle-view="toggleView" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    FeatureHighlight: () => import('~/modules/v2/FeatureHighlight.vue'),
    GetTrial: () => import('~/modules/GetTrial.vue'),
    GetTrialV2: () => import('~/modules/v2/GetTrial.vue'),
    Login: () => import('~/modules/Login.vue'),
    LoginV2: () => import('~/modules/v2/Login.vue'),
    NavigateToLogin: () => import('~/modules/v2/NavigateToLogin.vue'),
    NavigateToTrial: () => import('~/modules/v2/NavigateToTrial.vue'),
    SignInSignUpImagesContent: () => import('~/modules/v2/SignInSignUpImagesContent.vue'),
  },
  props: {
    redirect: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isSignUpView: true,
    variant: 'v1',
  }),
  methods: {
    toggleView() {
      this.isSignUpView = !this.isSignUpView;
    },
  },
  mounted() {
    const { showLogin = false } = this.$route.query;
    this.$posthog?.onFeatureFlags(() => {
      const flagValue = this.$posthog?.getFeatureFlag('sign-signup-page-variant');

      if (flagValue) {
        this.variant = (flagValue === 'control') ? 'v1' : flagValue;
      }
    });

    this.isSignUpView = !showLogin;
  },
};
</script>

<style lang="scss" scoped>
:deep() {
  .el-input--large {
    .el-input__inner {
      height: rem(56px);
    }
  }
}

.login-page {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;

  @include media('<md') {
    gap: 0;
    flex-flow: column wrap;
    justify-content: center;
  }
}

.login-page__left-boxes {
  flex-basis: 1360px;
  justify-content: space-between;

  @include media('<md') {
    justify-content: center;
  }
}

.login-page__right-boxes {
  align-items: center;
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: rem(80px);
  justify-content: center;

  @include media('<lg') {
    gap: rem(56px);
  }

  @include media('<md') {
    display: flex;
    gap: 0;
    justify-content: flex-start;
    flex: 1;
  }
}

.change-order {
  .login-page__images,
  .images--center {
    order: 1;

    @include media('<md') {
      order: 0;
    }
  }
}

.login-page__images {
  padding-top: rem(10px);
  display: flex;
  flex: 1;
  background: $--color-background;
  height: 100%;
  width: 100%;
  align-items: flex-end;
  justify-content: flex-end;

  &--center {
    justify-content: center;
  }

  &--left {
    justify-content: flex-start;
  }

  @include media('<md') {
    justify-content: center;
  }
}

.images--border-left {
  border-left: rem(1px) solid $--border-color-base;
  background: $white;
}

.images--border-right {
  border-right: rem(1px) solid $--border-color-base;
  background: $white;
}

.images--center {
  padding-top: rem(10px);
  display: flex;
  flex: 1;
  height: 100%;
  align-items: center;
  justify-content: center;

  @include media('<md') {
    display: none;
  }
}
</style>
